import React, { useRef, useState } from "react";
import { useEffect } from "react";

export default function LottiePlayer({ options, width, height }) {
  const lottieRef = useRef();
  const [compLoaded, setCompLoaded] = useState(false);
  const { Lottie } = lottieRef.current || {};
  useEffect(() => {
    lottieRef.current = {
      Lottie: require("react-lottie").default,
    };
    setCompLoaded(true);
  }, []);
  if (!compLoaded) {
    return;
  }
  return (
    <React.Fragment>
      {Lottie && <Lottie options={options} width={width} height={height} />}
    </React.Fragment>
  );
}
